import React, { useCallback, useEffect } from 'react';
import classNames from 'classnames';
import { CloseIcon } from 'components/icons';
import { Loader } from 'components/loader/Loader';

import './modal.styles.scss';

interface ModalWrapperProps {
	title?: string;
	onClose?: () => void;
	type?: string;
	wrapperClass?: string;
	contentWrapperClass?: string;
	showCloseIcon?: boolean;
	isDataLoading?: boolean;
}

export const ModalWrapper: React.FC<ModalWrapperProps> = ({
	children,
	title,
	onClose,
	type,
	showCloseIcon,
	wrapperClass = '',
	contentWrapperClass = '',
	isDataLoading,
}) => {
	const handleWrapperClick = (e: React.MouseEvent<HTMLDivElement>) => {
		if (e.target === e.currentTarget && onClose) {
			onClose();
		}
	};

	const keyUpListener = useCallback(
		(e: React.KeyboardEvent<HTMLDivElement> | KeyboardEvent) => {
			if (e.keyCode === 27 && onClose) {
				onClose();
			}
		},
		[onClose],
	);
	window.addEventListener('keyup', keyUpListener);

	useEffect(() => {
		return () => window.removeEventListener('keyup', keyUpListener);
	}, [keyUpListener]);

	return (
		<div
			className={classNames('modal', wrapperClass)}
			onClick={handleWrapperClick}
			role="button"
			tabIndex={0}
			onKeyUp={keyUpListener}
		>
			<div
				className={classNames(
					contentWrapperClass,
					type === 'result' ? 'modal-result' : 'modal-content',
				)}
			>
				<Loader isLoading={isDataLoading} overlay>
					{showCloseIcon && (
						<CloseIcon iconClass="modal-icon-close" onClick={onClose} />
					)}
					{title && <p className="modal__title">{title}</p>}
					{children}
				</Loader>
			</div>
		</div>
	);
};
